export default __webpack_public_path__ + "static/media/slider-img3.18cd2b1d.jpg";